import { prop } from 'lodash/fp';
import React from 'react';

const Switch = props => {
    return (
        <div className="custom-control custom-switch">
            <input
                onChange={props.onChange}
                type="checkbox"
                className="custom-control-input "
                checked={props.checked}
                id={props.id}
            />
            <label className="custom-control-label" htmlFor={props.id}></label>
        </div>
    )
}

export default Switch;